module.exports = __webpack_public_path__ + "img/Mickies_Pizzeria@3x.7a1db456.webp";